import cookieInfo from "@alife/bc-cookie-info";
export default () => cookieInfo.getBuyerLocale().split(/[-_]/i)[0] || 'en';